module.exports = __webpack_public_path__ + "static/media/petco.ab6bf708.svg";